module.exports = __webpack_public_path__ + "img/frink_beyaz_logo.201c1531.png";